import { render, staticRenderFns } from "./UsageHistory.vue?vue&type=template&id=94fa340c&scoped=true&"
import script from "./UsageHistory.vue?vue&type=script&lang=js&"
export * from "./UsageHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94fa340c",
  null
  
)

export default component.exports